import { Component, SimpleChanges, ElementRef, ViewChild ,HostListener} from '@angular/core';
import { SearchFilterService } from '../Services/search-filter.service';
import { NewsArticles, SearchStaticContent, SearchResults } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { LocationStrategy } from '@angular/common';

@Component({
    selector: 'internalarticle-search',
    templateUrl: './internalarticle-search.component.html',
    styles: []
})
export class InternalarticleSearchComponent {
    page: number;
    pageSize = 10; //No of pages per page
    maxPages = 10;
    startIndex: number;
    endIndex: number;
    pageOfItems: Array<any>;
    pager: any = {};
    filterbyValues: any[];
    noSearchText: string;
    isLoading: boolean = true;
    isTextSearch: boolean = false;
    filterText: string;
    selected: boolean = false;

    private _staticContent: SearchStaticContent;
    get staticContent(): SearchStaticContent {
        return this._staticContent;
    }
    set staticContent(value: SearchStaticContent) {
        this._staticContent = value;
    }

    private _newsArticles: SearchResults<NewsArticles>;
    get newsArticles(): SearchResults<NewsArticles> {
        return this._newsArticles;
    }
    set newsArticles(value: SearchResults<NewsArticles>) {
        this._newsArticles = value;
    }

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }

    @ViewChild('txtSearch') searchInput: ElementRef;
    @ViewChild('dnFilterText') filterDropdown: ElementRef;

    constructor(public dataService: SearchFilterService, public location: LocationStrategy) {
        var entries: any = performance.getEntriesByType("navigation")[0];
        if (entries.type == "reload" || entries.type == "navigate") {
            sessionStorage.clear();
        }
    }
    
    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    ngOnInit(): void {
        this.page = !isNaN(parseInt(sessionStorage.getItem('pageIndex'))) ? parseInt(sessionStorage.getItem('pageIndex')) : 1;
        this.searchText = sessionStorage.getItem('searchText') ? sessionStorage.getItem('searchText') : "";
        
        if (this.searchText != null && this.searchText != undefined && this.searchText != "")  {
            this.searchService(this.page, this.searchText);
        }
        else {
            this.peformSearch();
        }
        this.dataService.getfilterby().subscribe((data: any[]) => {
            this.filterbyValues = data;
        })

        if (sessionStorage.getItem('filterIndex') != undefined && sessionStorage.getItem('filterIndex') != null) {
            var selectedIndex = sessionStorage.getItem('filterIndex');
            if (this.filterDropdown != undefined) {
                this.filterDropdown.nativeElement.options[selectedIndex].selected = true;
            }
        }
    }

    performTextSearch(event) {
        this.isTextSearch = true;
        this.page = 1;

        if (this.searchText != null || this.searchText != undefined) {
            sessionStorage.setItem('searchText', this.searchText);
            this.searchService(this.page, this.searchText)
        }
    }

    searchService(page, searchString) {
        this.dataService.getInternalNewsArticles(page, searchString).subscribe((data: SearchResults<NewsArticles>) => {
            this.pageSize = data.PageSize;
            this.newsArticles = data;
            this.setPage(this.newsArticles);
            this.isLoading = false;

            window.location.href = "#topofbody";
        })

        this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
            this.staticContent = data;
            this.pageSize = data.PageSize;
        })
    }

    onChangePage(pageOfItems: any) {
        // update current page of items and set the number of items on page change
        sessionStorage.setItem('pageIndex', pageOfItems)
        if (this.isTextSearch) {
            if (this.searchText != null || this.searchText != undefined) {
                this.searchService(this.page, this.searchText);
            }
        }
        else {
            if (this.filterText != undefined && this.filterText !='No filter') {
                this.searchService(this.page, this.filterText);
            }
            else {
                this.peformSearch();
            }
        }
    }

    peformSearch(): void {
        this.isLoading = true;
        this.isTextSearch = false;

        
        this.dataService.getInternalNewsArticles(this.page, "").subscribe((data: SearchResults<NewsArticles>) => {
            this.pageSize = data.PageSize;
            this.newsArticles = data;
            this.setPage(this.newsArticles);
            this.isLoading = false;

            window.location.href = "#topofbody";

        })
        this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
            this.staticContent = data;
            this.pageSize = data.PageSize;
        })
    }

    onFilterChange(filterby: any) {
        this.page = 1;
        this.isTextSearch = false;
        let selectedOptions = event.target['options'];
        let selectedIndex = selectedOptions.selectedIndex;
        let selectElementText = selectedOptions[selectedIndex].text;
        this.searchInput.nativeElement.value = "";//clear the search input value.
        this.filterText = selectElementText;
        sessionStorage.setItem('filterIndex', selectedIndex);
        if (selectedIndex == "0") {
            this.searchService(this.page, "");
        }
        else {
            this.searchService(this.page, selectElementText);
        }

    }

    setPage(article: SearchResults<NewsArticles>) {
        this.pager = paginate(article.TotalMatching, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }
}
